module.exports = __webpack_public_path__ + "static/media/purse.0a7b5e14.png";